import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { SmsProviderAutoCompleteInput$, SmsProviderAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const SmsProviderAutoSuggest = renderAutoSuggestWithOptions(
   SmsProviderAutoCompleteObservable$,
   SmsProviderAutoCompleteInput$,
);

SmsProviderAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search for provider...',
};

export default SmsProviderAutoSuggest;
